<template>
  <div class="brand-detail" v-if="brand">
    <section-header tag="h1" class="mt-5 mb-5" :title="brand.brandName" subtitle="Brand"/>
    <section>
      <div class="row align-items-center">
        <div class="col-xl-2 col-md-3 col-4">
          <div class="logo border border-secondary" :style="util.getImageStyle(brand.originalImg)"></div>
        </div>
        <div class="col-xl-10 col-md-9 col-8 desc">{{ brand.brandDesc }}</div>
      </div>
    </section>
    <section class="mt-5">
      <list-control-panel
        :layout="layout" @layout="onLayoutChanged"
        :sort="sort" @sort="onSortChanged"
        :limit="limit" @limit="onLimitChanged"/>
      <product-grid class="mt-5" v-show="layout === layoutOptions.GRID" :products="products"/>
      <product-list class="mt-5" v-show="layout === layoutOptions.LIST" :products="products"/>
      <list-pagination :page="page" :limit="limit" :total="total" @page="onPageChanged" />
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import { mapGetters, mapMutations } from 'vuex'
import productApi from '@/api/product.js'
import SectionHeader from '@/components/SectionHeader.vue'
import ListControlPanel from '@/components/ListControlPanel.vue'
import ListPagination from '@/components/ListPagination.vue'
import ProductGrid from '@/components/Product/ProductGrid.vue'
import ProductList from '@/components/Product/ProductList.vue'

export default {
  name: 'BrandDetail',
  components: {
    SectionHeader,
    ListControlPanel,
    ListPagination,
    ProductGrid,
    ProductList
  },
  data: function () {
    return {
      products: null,
      total: 0
    }
  },
  computed: {
    ...mapGetters([
      'getBrand'
    ]),
    util: function () {
      return util
    },
    layoutOptions: function () {
      return constant.PRODUCT_LAYOUT
    },
    brandId: function () {
      return this.$route.params.id ? Number(this.$route.params.id) : null
    },
    brand: function () {
      return this.getBrand(this.brandId)
    },
    layout: function () {
      var ret = this.$route.query.layout
      if (!ret) {
        ret = constant.PRODUCT_LAYOUT.GRID
      }
      return ret
    },
    sort: function () {
      var ret = this.$route.query.sort
      if (!ret) {
        ret = constant.FILTER.SORT[0].value
      }
      return ret
    },
    limit: function () {
      var ret = this.$route.query.limit
      if (!ret) {
        ret = constant.FILTER.LIMIT[0]
      }
      return Number(ret)
    },
    page: function () {
      var ret = this.$route.query.page
      if (!ret) {
        ret = 0
      }
      return Number(ret)
    }
  },
  watch: {
    brandId: function (value) {
      this.refresh()
    },
    page: function (value) {
      this.refresh()
    },
    limit: function (value) {
      this.refresh()
    },
    sort: function (value) {
      this.refresh()
    }
  },
  mounted: function () {
    this.apiGetProductTotal()
    this.apiGetProducts()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetProducts: function () {
      var self = this
      var filter = {
        page: this.page,
        limit: this.limit,
        sort: this.sort
      }
      productApi.getBrandProducts(this.brandId, filter, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.products = rspData
      })
    },
    apiGetProductTotal: function () {
      var self = this
      productApi.getBrandTotal(this.brandId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.total = rspData
      })
    },
    refresh: function () {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      this.apiGetProducts()
    },
    onLayoutChanged: function (value) {
      if (!value) {
        return
      }
      this.$router.push(`/w/brand/detail/${this.brandId}?layout=${value}&sort=${this.sort}&page=${this.page}&limit=${this.limit}`)
    },
    onSortChanged: function (value) {
      if (!value) {
        return
      }
      this.$router.push(`/w/brand/detail/${this.brandId}?layout=${this.layout}&sort=${value}&page=${this.page}&limit=${this.limit}`)
    },
    onLimitChanged: function (value) {
      if (!value) {
        return
      }
      this.$router.push(`/w/brand/detail/${this.brandId}?layout=${this.layout}&sort=${this.sort}&page=0&limit=${value}`)
    },
    onPageChanged: function (value) {
      this.$router.push(`/w/brand/detail/${this.brandId}?layout=${this.layout}&sort=${this.sort}&page=${value}&limit=${this.limit}`)
    }
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
  padding-bottom: 30%;
}
.logo {
  width: 100%;
  padding-bottom: 62%;
}
.desc {
  font-size: 1.1rem;
  font-weight: 500;
  white-space: pre-line;
}
</style>
